// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "container-3-tDn";
var _5 = "inner-1m7tV";
var _6 = "header-1yx2C";
var _7 = "services-KurZW";
var _8 = "notice-3q_mG";
var _9 = "notice__icon-1IOme";
var _a = "notice__link-3hZ7_";
var _b = "notice__notes-1AzzM";
var _c = "details-Desy5";
var _d = "details__button-1EgFV";
var _e = "travellers-2FUOM";
var _f = "traveller-3_KzE";
var _10 = "traveller__name-2cXye";
var _11 = "button-GlBaw";
var _12 = "button_passenger-3xtjr";
var _13 = "button_selected-Tx2gb";
var _14 = "button_disabled-3o8c4";
var _15 = "traveller__controls-6JYWF";
var _16 = "rules__content-31Qc9";
var _17 = "close-394iX";
var _18 = "refunded-3JjMu";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "container", _5 as "inner", _6 as "header", _7 as "services", _8 as "notice", _9 as "notice__icon", _a as "notice__link", _b as "notice__notes", _c as "details", _d as "details__button", _e as "travellers", _f as "traveller", _10 as "traveller__name", _11 as "button", _12 as "button_passenger", _13 as "button_selected", _14 as "button_disabled", _15 as "traveller__controls", _16 as "rules__content", _17 as "close", _18 as "refunded" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "container": _4, "inner": _5, "header": _6, "services": _7, "notice": _8, "notice__icon": _9, "notice__link": _a, "notice__notes": _b, "details": _c, "details__button": _d, "travellers": _e, "traveller": _f, "traveller__name": _10, "button": _11, "button_passenger": _12, "button_selected": _13, "button_disabled": _14, "traveller__controls": _15, "rules__content": _16, "close": _17, "refunded": _18 }
